import { FileUploadInterface } from './Profile';
import { MetaDataElement } from './metaDataConfig';

export interface optionsInterface {
  key: string;
  text: string;
  value: string;
}

export interface VerifyInterface {
  parentPane: string;
  childPane: string;
  ftpPath: string;
  isCloned: boolean;
  number_of_elem: string;
  current_user: string;
  id: string;
  original_title: string;
  translated_title: string;
  alternative_title: string;
  original_language_origin: string;
  original_language: string;
  dubbed_language_origin: string;
  dubbed_language: string;
  country_production: string;
  original_production_format: string;
  released_unreleased: string;
  year_reference: string;
  work_category: string;
  certification_no: string;
  certification_center: string;
  certification_date: string;
  synopsis: string;
  length_of_film: string;
  duration: string;
  total_can_count: number;
  banner: string;
  production_company: string;
  producer: string;
  associate_producer: string;
  executive_producer: string;
  director: string;
  story: string;
  screen_play: string;
  dialogue: string;
  cinematography: string;
  photography: string;
  editing: string;
  art_direction: string;
  sound_recordist: string;
  sound_mixing: string;
  sound_designer: string;
  sound_effects: string;
  dubbing: string;
  music: string;
  music_background_score: string;
  lyricist: string;
  songs: string;
  cast: string;
  playback_singers: string;
  costume: string;
  action: string;
  choreography: string;
  make_up: string;
  associate_director: string;
  associate_directors: string;
  other_assistants: string;
  production_manager: string;
  production_studio: string;
  film_processing_laboratory: string;
  vfx: string;
  animator: string;
  colorist: string;
  cgi: string;
  di: string;
  public_designer: string;
  awards: string;
  screening: string;
  notes: string;
  copyright: string;
  audio_right: string;
  recording_company: string;
  keywords: string;
  curatorial_notes: string;
  proxy: string;
  thumbnail_large: string;
  thumbnail_small: string;
  thumbnail: string;
  preview: string;
  physical_sensor_qrcode: string;
  physical_sensor_barcode: string;
  physical_sensor_RFID: string;
  physical_sensor_NFC: string;
  physical_location_vault: string;
  physical_location_rack: string;
  physical_location_shelf: string;
  last_modified: string;
  movementdate: string;
  content_created: string;
  name: string;
  ingest_server: string;
  technical_type: string;
  source_name: string;
  tc_start: string;
  tc_End: string;
  tc_duaration: string;
  play_duration: string;
  tracks: string;
  tape: string;
  frame_rate: string;
  video_format: string;
  compression: string;
  orientation: string;
  aspect_ratio: string;
  file: string;
  size: string;
  physcial_format: string;
  track_format: string;
  groove_type: string;
  speed_and_speed_adjustment: string;
  number_of_channels_and_sound_channel_map: string;
  sampling_frequency: string;
  audio_data_encoding: string;
  file_format_name_and_version: string;
  encodeder: string;
  file_format: string;
  durationn: string;
  timecode: string;
  video: string;
  dimensions: string;
  analog_media: string;
  frame_description: string;
  data_rate: string;
  format_in_terms_of_broadcast_standards: string;
  formatting_description: string;
  bits_per_sample_and_sampling_description: string;
  gauge_type: string;
  reel_no: string;
  calculated_category: number;
  typeid: string;
  cloned_From: string;
  files: FileUploadInterface[];
  photos: FileUploadInterface[];
  metadata: MetaDataElement[];
  registerId: string;
}
export const tabVerifyData = {
  parentPane: '',
  childPane: '',
  ftpPath: '',
  number_of_elem: '',
  movementdate: '',
  id: '',
  current_user: '',
  current_task: '',
  current_subtask: '',
  isCloned: false,
  original_title: '',
  translated_title: '',
  alternative_title: '',
  original_language_origin: '',
  original_language: '',
  dubbed_language_origin: '',
  dubbed_language: '',
  country_production: '',
  original_production_format: '',
  released_unreleased: '',
  year_reference: '',
  work_category: '',
  certification_no: '',
  certification_center: '',
  certification_date: '',
  synopsis: '',
  length_of_film: '',
  duration: '',
  total_can_count: 0,
  banner: '',
  production_company: '',
  producer: '',
  associate_producer: '',
  executive_producer: '',
  director: '',
  story: '',
  screen_play: '',
  dialogue: '',
  cinematography: '',
  photography: '',
  editing: '',
  art_direction: '',
  sound_recordist: '',
  sound_mixing: '',
  sound_designer: '',
  sound_effects: '',
  dubbing: '',
  music: '',
  music_background_score: '',
  lyricist: '',
  songs: '',
  cast: '',
  playback_singers: '',
  costume: '',
  action: '',
  choreography: '',
  make_up: '',
  associate_director: '',
  associate_directors: '',
  other_assistants: '',
  production_manager: '',
  production_studio: '',
  film_processing_laboratory: '',
  vfx: '',
  animator: '',
  colorist: '',
  cgi: '',
  di: '',
  public_designer: '',
  awards: '',
  screening: '',
  notes: '',
  copyright: '',
  audio_right: '',
  recording_company: '',
  keywords: '',
  curatorial_notes: '',
  proxy: '',
  thumbnail_large: '',
  thumbnail_small: '',
  thumbnail: '',
  preview: '',
  physical_sensor_qrcode: '',
  physical_sensor_barcode: '',
  physical_sensor_RFID: '',
  physical_sensor_NFC: '',
  physical_location_vault: '',
  physical_location_rack: '',
  physical_location_shelf: '',
  last_modified: '',
  content_created: '',
  name: '',
  ingest_server: '',
  technical_type: '',
  source_name: '',
  tc_start: '',
  tc_End: '',
  tc_duaration: '',
  play_duration: '',
  tracks: '',
  tape: '',
  frame_rate: '',
  video_format: '',
  compression: '',
  orientation: '',
  aspect_ratio: '',
  file: '',
  size: '',
  physcial_format: '',
  track_format: '',
  groove_type: '',
  speed_and_speed_adjustment: '',
  number_of_channels_and_sound_channel_map: '',
  sampling_frequency: '',
  audio_data_encoding: '',
  file_format_name_and_version: '',
  encodeder: '',
  file_format: '',
  durationn: '',
  timecode: '',
  video: '',
  dimensions: '',
  analog_media: '',
  frame_description: '',
  data_rate: '',
  format_in_terms_of_broadcast_standards: '',
  formatting_description: '',
  bits_per_sample_and_sampling_description: '',
  calculated_category: 0,
  gauge_type: '',
  reel_no: '',
  typeid: '',
  cloned_From: '',
  files: [],
  photos: [],
  metadata: [],
  registerId: '',
};
